import { css } from '@emotion/core';

import { flex } from '@/styles';

export const settingsButtonStyles = css`
  button {
    display: flex;
    align-items: center;
    padding: 0 5px;
    span {
      ${flex}
    }
  }
`;
